import { Theme, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles<Theme>((theme) => ({
  container: {
    display: "flex",
    gap: "16px",
  },
  typography: {
    fontWeight: "var(--button-small-font-weight)" as any, // Cast to any
    fontSize: "var(--button-small-font-size)" as any,
    letterSpacing: "var(--button-small-letter-spacing)" as any,
    lineHeight: "var(--button-small-line-height)" as any,
    fontStyle: "var(--button-small-font-style)" as any,
    paddingRight: '16px'
  },
  chipLabel: {
    fontWeight: "var(--chip-label-font-weight)" as any,
    fontSize: "var(--chip-label-font-size)" as any,
    letterSpacing: "var(--chip-label-letter-spacing)" as any,
    lineHeight: "var(--chip-label-line-height)" as any,
    fontStyle: "var(--chip-label-font-style)" as any,
  },
  chip: {
    borderRadius: "100px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0px 16px 0px 0px !important",
  },
  chipFilled: {
    borderColor: "#1976d2",
    backgroundColor: "#007db8 !important", // Use !important as a last resort
    color: "#ffffff !important",
  },
  chipOutlined: {
    borderColor: "#bdbdbd",
    backgroundColor: "transparent",
    color: "#000000",
  },
  chipCount: {
    fontWeight: "bold",
  },
}));

export default useStyles;
